import { Box, CircularProgress } from "@mui/material";
import { Loader } from "../../Assets/Images/Images";
import Colors from "../../Assets/Styles/Colors";

export const CircleLoading = () => {
  return (
    <Box sx={{ display: 'block', position: 'relative', justifyContent: 'center', alignItems: 'center', minHeight: 380, height: 'calc(100vh - 210px)' }}>
      <Box sx={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)' }}>
        <Loader />
      </Box>
    </Box>
  );
};

export const CircularLoading = () => {
  return (
    <Box sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <CircularProgress sx={{ color: Colors.primary }} />
    </Box>
  );
};